import { render, staticRenderFns } from "./InvestorBeneficiaries.vue?vue&type=template&id=31824f44&scoped=true&"
import script from "./InvestorBeneficiaries.vue?vue&type=script&lang=js&"
export * from "./InvestorBeneficiaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31824f44",
  null
  
)

export default component.exports